import { render, staticRenderFns } from "./WelcomeView.vue?vue&type=template&id=ef250b0a&scoped=true&"
import script from "./WelcomeView.vue?vue&type=script&lang=js&"
export * from "./WelcomeView.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeView.vue?vue&type=style&index=0&id=ef250b0a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef250b0a",
  null
  
)

export default component.exports